import React, { useEffect, useState, useRef } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Label
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import CompoundService from "services/Admin/CompoundService"
import UnitTypesService from "services/Admin/UnitTypesService"
import PropertyService from "services/Admin/PropertyService";
import SelectOptions from "components/SelectOptions"
import Select from "react-select";
import PriceInput from "components/PriceInput"
import CurrencyInput from 'react-currency-input-field';
import { toast } from "react-toastify";
import moment from "moment"
const initialFormData = {
    unit_type_ids: null,
    min_price: "",
    max_price: "",
    from_date: "",
    to_date: "",
    compound_ids: null
}
const FilterModal = ({ modal, toggle, onSumbit,filterData }) => {
    const [formData, setFormData] = useState(initialFormData)
    const [unitTypeOptions, setUnitTypeOptions] = useState([])
    const [compoundOptions, setCompoundOptions] = useState([])
    const formRef = useRef()
    const handleFieldChange = (e) => {
            setFormData({ ...formData, [e.target.name]: e.target.value });
     };

     useEffect(() => {
        if (!formData.min_price) {
            setFormData((state) => ({ ...state, min_price: "" }))
        }
        if (!formData.max_price) {
            setFormData((state) => ({ ...state, max_price: "" }))
        }
    }, [formData.min_price, formData.max_price])

     useEffect(()=>{
        if (filterData ?.min_price ?.length) setFormData((state) => ({ ...state, min_price: filterData.min_price }))
        if (filterData ?.max_price ?.length) setFormData((state) => ({ ...state, max_price: filterData.max_price }))
        if (filterData ?.from_date ?.length) setFormData((state) => ({ ...state, from_date: filterData.from_date }))
        if (filterData ?.to_date ?.length) setFormData((state) => ({ ...state, to_date: filterData.to_date }))
        if (filterData ?.compound_ids?.length) setFormData((state) => ({ ...state, compound_ids: filterData.compound_ids }))
        if (filterData ?.unit_type_ids?.length) setFormData((state) => ({ ...state, unit_type_ids: filterData.unit_type_ids }))

    },[])
    return (
        <AvForm ref={formRef} className='form-horizontal'>
            <Modal isOpen={modal} toggle={toggle}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={toggle}>
                    Deals Filters
                </ModalHeader>
                <ModalBody className="pb-0">
                    <Col md={12}>
                        <SelectOptions
                            label='Unit Type'
                            placeholder='Select'
                            options={unitTypeOptions}
                            handleSelectChange={(data) => {
                                setFormData({ ...formData, unit_type_ids: data });
                            }}
                            selectedOption={formData.unit_type_ids}
                            Service={UnitTypesService}
                            setOptions={(options) => {
                                setUnitTypeOptions(options)
                            }}
                            isMulti={true}
                        />
                    </Col>
                    <Col md={12}>
                        <SelectOptions
                            label='Compound'
                            placeholder='Select'
                            options={compoundOptions}
                            handleSelectChange={(data) => {
                                setFormData({ ...formData, compound_ids: data });
                            }}
                            selectedOption={formData.compound_ids}
                            Service={CompoundService}
                            setOptions={(options) => {
                                setCompoundOptions(options)
                            }}
                            isMulti={true}
                        />
                    </Col>
                    <Row>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='from_date'
                                    label="From Date"
                                    className='form-control'
                                    type='date'
                                    onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formData.from_date}

                                />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='to_date'
                                    label="To Date"
                                    className='form-control'
                                    type='date'
                                    onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formData.to_date}

                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="my-2 p-0">
                        <Label className="mx-2 px-1">Price</Label>
                    </Row>
                    <Row className="p-0 m-0">
                        <Col md={6} className="price-input" style={{ height: "86px", paddingLeft: 0 }}>
                            <CurrencyInput
                                id="min_price"
                                className="px-2 py-3"
                                name="min_price"
                                placeholder="From"
                                value={formData.min_price}
                                allowNegativeValue={false}
                                decimalsLimit={2}
                                onValueChange={(value, name) => {
                                    if(value===undefined){
                                        setFormData({ ...formData, min_price: "" })

                                    }else{
                                        setFormData({ ...formData, min_price: value })

                                    }
                                 }}
                            />
                        </Col>
                        <Col md={6} className="price-input" style={{ height: "86px", paddingRight: 0 }}  >
                            <CurrencyInput
                                id="max_price"
                                className="px-2 py-3"
                                name="max_price"
                                placeholder="To"
                                value={formData.max_price}
                                allowNegativeValue={false}
                                decimalsLimit={2}
                                onValueChange={(value, name) => {
                                    if(value===undefined){
                                        setFormData({ ...formData, max_price: "" })

                                    }else{
                                        setFormData({ ...formData, max_price: value })

                                    }
                                 }}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className=" px-0 d-flex justify-content-between">
                    <button type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            setFormData(initialFormData)
                            onSumbit(initialFormData)
                            formRef.current.reset()

                        }}>
                        Reset Filter
                                </button>
                    <button type='button' onClick={() => {
                       if ((formData.from_date && formData.to_date) && moment(formData.to_date).isBefore(formData.from_date)) {
                            toast.error("Date range not valid")
                            return
                        }  else if (formData.min_price === 0 ||
                            formData.max_price === 0) {
                            toast.error(" price must be greater than zero ")
                            return
                        } else if (parseFloat(formData.max_price) < parseFloat(formData.min_price)) {
                            toast.error(" Price range not valid ")
                            return
                        } else {
                            onSumbit(formData)
                            toggle()
                        }

                    }} className='btn btn-success  w-120'>
                        Apply Filter
                                </button>

                </ModalFooter>
            </Modal>
        </AvForm>

    )
}
export default FilterModal